module.exports = __webpack_public_path__ + "static/media/job_floor.61b2054b.svg";